import { format } from "date-fns/format";
import { de, enUS, es } from "date-fns/locale";

import { LocalizedLanguages } from "@/constants/languages";

const localeMap = {
    [LocalizedLanguages.EnglishUS]: enUS,
    [LocalizedLanguages.SpanishES]: es,
    [LocalizedLanguages.GermanDE]: de,
};

export const formatDate = (
    dateBase: string | Date,
    options?: { lng?: LocalizedLanguages; format?: string }
) => {
    const formatString = options?.format ?? "MMMM d";
    const lng = options?.lng ?? LocalizedLanguages.EnglishUS;

    const date = new Date(dateBase);

    return format(date, formatString, { locale: localeMap[lng] });
};
